import ReactPaginate from 'react-paginate';

interface paginationProps {
  pagesCount: number;
  onPageChange: (page: number) => void;
  activePage: number;
}

const Pagination = (props: paginationProps) => {
  return (
    <ReactPaginate
      previousLabel={''}
      nextLabel={''}
      pageCount={props.pagesCount}
      activeClassName="active"
      forcePage={props.activePage}
      onPageChange={(page) => props.onPageChange(page.selected + 1)}
      pageClassName={'page-item'}
      nextLinkClassName={'page-link'}
      nextClassName={'page-item next'}
      previousClassName={'page-item prev'}
      previousLinkClassName={'page-link'}
      pageLinkClassName={'page-link'}
      containerClassName={
        'pagination react-paginate justify-content-end my-2 pe-1'
      }
      marginPagesDisplayed={-10}
      pageRangeDisplayed={7}
    />
  );
};

export default Pagination;
